export const GETTZAP_HOST = 'https://gettzap.ru'
export const B2B_GETTZAP_HOST = 'https://b2b.gettzap.ru'